function getIssuedAtFromAccessToken(token) {
  const raw_token = token.replace("JWT ", "");
  const raw_payload = raw_token.split(".")[1];
  const payload = JSON.parse(atob(raw_payload));
  const iat_milliseconds = 1000 * payload.iat;
  return new Date(iat_milliseconds);
}

export { getIssuedAtFromAccessToken };



// WEBPACK FOOTER //
// ./src/components/login/loginUtils.js